export default __webpack_public_path__ + "static/media/Group9179.5024c1e3.svg";